<script setup>
import { ref, defineProps, toRefs } from "vue";
import useStoreCotizaciones from "@/store/cotizaciones";
import { storeToRefs } from "pinia";

const {
  plazo12,
  plazo24,
  plazo36,
  plazo48,
  plazo60,
  stateCotizacionEditable,
} = storeToRefs(useStoreCotizaciones());

const props = defineProps({
  totales: {
    type: Object,
    required: true,
  },
  showSwitch: {
    type: Boolean,
    default: true,
  },
  index: {
    type: Number,
    required: true,
  },
});
const { totales, showSwitch } = toRefs(props);
const cardClass = ref("bg-gradient-warning");
const cardChecked = ref(true);
const showCard = ref(true);

stateCotizacionEditable.value[props.index].desembolso_inicial_neto =
  props.totales.desembolso_inicial_neto;
stateCotizacionEditable.value[props.index].renta_mensual =
  props.totales.renta_mensual;
stateCotizacionEditable.value[props.index].valor_residual_neto =
  props.totales.valor_residual_neto;
stateCotizacionEditable.value[props.index].ahorro_isr =
  props.totales.ahorro_isr;

const toggleClassCard = (val) => {
  const newVal = val == "false" ? true : false;
  cardChecked.value = newVal;

  newVal
    ? (cardClass.value = "bg-gradient-warning")
    : (cardClass.value = "bg-gradient-secondary");

  if (totales.value.plazo == "12" && plazo12.value == "00") {
    plazo12.value = 12;
  } else if (totales.value.plazo == "12" && plazo12.value == "12") {
    plazo12.value = "00";
  }

  if (totales.value.plazo == "24" && plazo24.value == "00") {
    plazo24.value = 24;
  } else if (totales.value.plazo == "24" && plazo24.value == "24") {
    plazo24.value = "00";
  }

  if (totales.value.plazo == "36" && plazo36.value == "00") {
    plazo36.value = 36;
  } else if (totales.value.plazo == "36" && plazo36.value == "36") {
    plazo36.value = "00";
  }

  if (totales.value.plazo == "48" && plazo48.value == "00") {
    plazo48.value = 48;
  } else if (totales.value.plazo == "48" && plazo48.value == "48") {
    plazo48.value = "00";
  }

  if (totales.value.plazo == "60" && plazo60.value == "00") {
    plazo60.value = 60;
  } else if (totales.value.plazo == "60" && plazo60.value == "60") {
    plazo60.value = "00";
  }
};

if (totales.value.plazo == 12) {
  plazo12.value == "00"
    ? (cardChecked.value = false)
    : (cardChecked.value = true);

  plazo12.value == "00"
    ? (cardClass.value = "bg-gradient-secondary")
    : (cardClass.value = "bg-gradient-warning");

  if (plazo12.value == "00" && !showSwitch.value) {
    showCard.value = false;
  }
}

if (totales.value.plazo == 24) {
  plazo24.value == "00"
    ? (cardChecked.value = false)
    : (cardChecked.value = true);

  plazo24.value == "00"
    ? (cardClass.value = "bg-gradient-secondary")
    : (cardClass.value = "bg-gradient-warning");

  if (plazo24.value == "00" && !showSwitch.value) {
    showCard.value = false;
  }
}

if (totales.value.plazo == 36) {
  plazo36.value == "00"
    ? (cardChecked.value = false)
    : (cardChecked.value = true);

  plazo36.value == "00"
    ? (cardClass.value = "bg-gradient-secondary")
    : (cardClass.value = "bg-gradient-warning");

  if (plazo36.value == "00" && !showSwitch.value) {
    showCard.value = false;
  }
}

if (totales.value.plazo == 48) {
  plazo48.value == "00"
    ? (cardChecked.value = false)
    : (cardChecked.value = true);

  plazo48.value == "00"
    ? (cardClass.value = "bg-gradient-secondary")
    : (cardClass.value = "bg-gradient-warning");

  if (plazo48.value == "00" && !showSwitch.value) {
    showCard.value = false;
  }
}

if (totales.value.plazo == 60) {
  plazo60.value == "00"
    ? (cardChecked.value = false)
    : (cardChecked.value = true);

  plazo60.value == "00"
    ? (cardClass.value = "bg-gradient-secondary")
    : (cardClass.value = "bg-gradient-warning");

  if (plazo60.value == "00" && !showSwitch.value) {
    showCard.value = false;
  }
}

//checkCardClass(totales.value.plazo);

const idUsuario = localStorage.getItem("_id");
</script>
<template>
  <tr
    class="text-center text-dark fw-bold"
    v-show="showCard"
    :class="cardChecked ? '' : 'opacity-2'"
  >
    <td
      width="10"
      class="text-center border-bottom border-dark bg-white"
      v-if="showSwitch"
    >
      <div class="form-check form-switch ms-auto pe-2 pt-3 pb-0">
        <input
          id="flexSwitchCheckHumidity"
          class="form-check-input mx-auto"
          type="checkbox"
          :value="cardChecked"
          :checked="cardChecked"
          @change="toggleClassCard($event.target.value)"
          v-if="showSwitch"
        />
      </div>
    </td>
    <td class="py-4 bg-white border-bottom border-dark">
      {{ totales.plazo }} Meses
    </td>
    <td class="py-4 bg-light border-bottom border-dark">
      $<input
        v-model="stateCotizacionEditable[index].desembolso_inicial_neto"
        class="input-editable"
        :disabled="idUsuario == 9 ? false : true"
      />
    </td>
    <td class="py-4 bg-warning border-bottom border-dark">
      $<input
        v-model="stateCotizacionEditable[index].renta_mensual"
        class="input-editable"
        :disabled="idUsuario == 9 ? false : true"
      />
    </td>
    <td class="py-4 bg-light border-bottom border-dark">
      $<input
        v-model="stateCotizacionEditable[index].valor_residual_neto"
        class="input-editable"
        :disabled="idUsuario == 9 ? false : true"
      />
    </td>
    <td width="10" class="py-4 bg-white border-bottom border-dark">
      $<input
        v-model="stateCotizacionEditable[index].ahorro_isr"
        class="input-editable"
        :disabled="idUsuario == 9 ? false : true"
      />
    </td>
  </tr>
</template>

<style scoped>
.verticaltext_content {
  transform: rotate(-270deg);
  -webkit-transform: rotate(-270deg);
  -moz-transform: rotate(-270deg);
  -ms-transform: rotate(-270deg);
  -o-transform: rotate(-270deg);
  right: 0 !important;
  filter: progid:DXImageTransform.Microsoft.BasicImage(rotation=3);
  opacity: 0.7;
  margin-right: -24px;
  top: 45% !important;
  color: #fff;
  text-transform: uppercase;
  font-size: 26px;
  font-weight: bold;
  text-align: center;
}

.input-editable {
  background: transparent;
  width: 150px;
  text-align: center;
  border: none;
  font-weight: bold;
}
</style>
